import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './contexts/ThemeContext';

// Suppress MetaMask extension errors from showing in the local development overlay
if (process.env.NODE_ENV === 'development') {
  const observer = new MutationObserver(() => {
    const overlay = document.querySelector('iframe[style*="z-index: 2147483647"]');
    if (overlay) {
      overlay.remove();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Rendering the root React component
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Optional: Measure performance
reportWebVitals();
